import { FormatterInput } from "@fullcalendar/core";
import { TaskCalendarStatus } from "./types";

export const SCHEDULE_STATUS_COLORS: Record<string, string> = {
  [TaskCalendarStatus.FAILED]: "bg-red-400",
  [TaskCalendarStatus.COMPLETED]: "bg-green-500",
  [TaskCalendarStatus.PENDING]: "bg-yellow-400",
  [TaskCalendarStatus.ACTIVE]: "bg-green-500",
  [TaskCalendarStatus.INACTIVE]: "bg-gray-400",
};

/** 24-hour "HH:mm"; h23 (not hour12: false) so midnight is 00:00, never 24:00. */
export const CALENDAR_TIME_FORMAT: FormatterInput = {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
};
